import { z } from 'zod';
import { JobInvoicingChronicleType, JobRestorationChronicleType } from './jobChronicles.js';
export const JobSubcontractorChronicleTypeSchema = z.enum([
    JobRestorationChronicleType.appointmentCompleted,
    JobRestorationChronicleType.appointmentScheduled,
    JobRestorationChronicleType.cancelled,
    JobRestorationChronicleType.completed,
    JobRestorationChronicleType.customerContactAttempted,
    JobRestorationChronicleType.received,
    JobRestorationChronicleType.started,
    JobRestorationChronicleType.withdrawn,
    JobRestorationChronicleType.workDetailsReceived,
    JobInvoicingChronicleType.jobBillCreated,
    JobInvoicingChronicleType.jobBillPaymentMade,
    JobInvoicingChronicleType.jobBillUpdated,
]);
export const JobSubcontractorChronicleType = JobSubcontractorChronicleTypeSchema.enum;
export const isJobSubcontractorChronicle = (chronicle) => JobSubcontractorChronicleTypeSchema.safeParse(chronicle.type).success;
/**
 * The JobSubcontractorTimeline chronicle types before compilation
 */
export const JobSubcontractorSourceTypeSchema = z.enum([
    ...JobSubcontractorChronicleTypeSchema.options,
    JobRestorationChronicleType.reopened,
]);
export const JobSubcontractorSourceType = JobSubcontractorSourceTypeSchema.enum;
export const isJobSubcontractorSourceChronicle = (chronicle) => JobSubcontractorSourceTypeSchema.safeParse(chronicle.type).success;
